module.exports = __webpack_public_path__ + "static/img/logo_ecw.d08262ee.png";